import { store } from "redux/store";

const { GET_COMPOSITION_FROM_ID } = require("adapters/ehr.service");

// export const extractEncounterIdFromComposition = async ({ compositionId }) => {
//   //Accepts Composition ID (String) and fetches the composition resource, extracts referenced encounter ID from the resource and sets inside the Query params, parallel to the recording.
//   try {
//     const encounterObj = store?.getState()?.encounterObj?.encounter;
//     if (encounterObj?.id) return;
//     const compositionResource = await GET_COMPOSITION_FROM_ID(compositionId);
//     // Not a magic number
//     const encounterReference =
//       compositionResource?.entry?.[0]?.resource?.encounter?.reference; // Only one resource will be recieved, as provided with id
//     const encounterId = encounterReference?.split("/")?.[1];
//     setEncounterIdInParams(encounterId);
//   } catch (error) {
//     console.error(error.message);
//   }
// };

export const setEncounterIdInParams = (encounterId) => {
  const url = window.location.search;
  const param = new URLSearchParams(url);
  if (param.get("visitId")) return;
  param.append("visitId", encounterId);
  // Update the URL in the browser
  const newUrl = `${window.location.pathname}?${param.toString()}`;
  window.history.replaceState({}, "", newUrl);
};
